import React from "react";
import { Col, Container, Row, Tab, Nav, Accordion } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Topfeatures() {
  return (
    <section className="top_health_features p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
            <h2>Top Features for Medical Software & Apps</h2>
            <p>
              At TekRevol, we provide exceptional medical app features that can
              be fully customized, adapted, and scalable. Our dedicated mHealth
              app developers create healthcare applications with creative
              features and user-friendly UI/UX designs. Explore our range of
              healthcare app features below:
            </p>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <Tab.Container id="" defaultActiveKey="0">
              <Nav variant="pills" className="flex-column">
                <div className="medical_item">
                  <Nav.Item>
                    <Nav.Link eventKey="0">Patient App</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="1">Hospital and Clinic Panel</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="2">
                      Apps For Medical Professionals
                    </Nav.Link>
                  </Nav.Item>
                </div>
              </Nav>
              <Row>
                <Tab.Content>
                  <Tab.Pane eventKey="0">
                    <Row>
                      <Col xs={12} md={6} lg={5} xl={4} xxl={4}>
                        <Accordion defaultActiveKey={null}>
                          <Accordion.Item eventKey="0">
                            <Accordion.Header>
                              Scheduling Appointments
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                                Say goodbye to long wait times and tedious
                                scheduling processes as our innovative doctor
                                appointment app development simplifies booking
                                appointments, and ensures flawless access to
                                healthcare professionals at your convenience.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="1">
                            <Accordion.Header>
                              Patient Educational Reminders
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                                We prioritize complete care by flawlessly
                                integrating patient education materials and
                                customized reminders.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="2">
                            <Accordion.Header>
                              Patient-Generated Data Tracking
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                                As pioneers in the healthcare application
                                development industry, we ensure the highest
                                standards of confidentiality and dependability
                                in our applications. We prioritize patient
                                safety and efficacy in our innovative solutions,
                                governed by the International Medical Device
                                Regulators Forum's (IMDRF) SaMD risk categories.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="3">
                            <Accordion.Header>
                              In-App Communication
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                                Our medical app creation includes the tracking
                                of patient-generated data, which makes it
                                possible to create individualized treatment
                                plans and superior healthcare insights.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="4">
                            <Accordion.Header>
                              Prescription Upload
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                                Our pharmacy app developers are experts in
                                allowing prescription uploads, which improves
                                the simplicity of medication management in
                                telemedicine apps.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="5">
                            <Accordion.Header>
                              Secure Payment Gateways
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                                For easy and safe transactions, our telemedicine
                                app development solutions provide smooth payment
                                processing across multiple platforms.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={6}
                        xl={7}
                        xxl={7}
                        className="text-center offset-lg-1"
                      >
                        <div className="top_health_img">
                          <StaticImage
                            src="../../images/services-usa/healthcare-new/top_features/patient_app.webp"
                            alt="patient-app"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={790}
                            height={553}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Tab.Pane>
                  <Tab.Pane eventKey="1">
                    <Row>
                      <Col xs={12} md={6} lg={5} xl={4} xxl={4}>
                        <Accordion defaultActiveKey={null}>
                          <Accordion.Item eventKey="0">
                            <Accordion.Header>
                              Health Activity Tracking
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                                To help customers successfully monitor and
                                manage their well-being, our healthcare app
                                solutions include health activity tracking.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="1">
                            <Accordion.Header>
                              Electronic Health Record (EHR) Systems
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                                Our medical app developers create flexible EHR
                                systems to guarantee safe and effective patient
                                health record administration, enhancing the
                                quality of care.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="2">
                            <Accordion.Header>
                              Staff Management
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                                Our healthcare mobile app development provides
                                staff management solutions to assist healthcare
                                organizations in optimizing workforce scheduling
                                and performance.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="3">
                            <Accordion.Header>
                              Claims Management
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                                Our healthcare app software development improves
                                claim settlement by automating documents and
                                assuring accuracy to reduce errors and costs.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="4">
                            <Accordion.Header>E-Prescription</Accordion.Header>
                            <Accordion.Body>
                              <p>
                                We modernize the prescription process with
                                E-prescription abilities, improving medication
                                management and patient care.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="5">
                            <Accordion.Header>
                              Business Analytics
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                                Our mobile health app developers incorporate the
                                latest business analytics tools to assist
                                healthcare providers make data-driven decisions.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={6}
                        xl={7}
                        xxl={7}
                        className="text-center offset-lg-1"
                      >
                        <div className="top_health_img">
                          <StaticImage
                            src="../../images/services-usa/healthcare-new/top_features/hospital_clinic.webp"
                            alt="hospital-clinic"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={782}
                            height={545}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Tab.Pane>
                  <Tab.Pane eventKey="2">
                    <Row>
                      <Col xs={12} md={6} lg={5} xl={4} xxl={4}>
                        <Accordion defaultActiveKey={null}>
                          <Accordion.Item eventKey="0">
                            <Accordion.Header>
                              Doctor/Patient Profile
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                                We craft apps that effortlessly include doctor
                                and patient profiles to allow them to access the
                                necessary details for informed decisions.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="1">
                            <Accordion.Header>Reviews</Accordion.Header>
                            <Accordion.Body>
                              <p>
                                Our apps allow users to easily access reviews,
                                which let them know the insights into healthcare
                                providers and services.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="2">
                            <Accordion.Header>
                              Reminders & Notifications
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                                We add reminder capabilities into our app to
                                keep patients informed about appointments,
                                medication, and essential healthcare updates.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="3">
                            <Accordion.Header>
                              Live Chat with Support
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                                Our healthcare app has a live chat with a
                                support feature, which allows users to contact
                                healthcare professionals for real-time
                                assistance and guidance.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="4">
                            <Accordion.Header>Medical Tips</Accordion.Header>
                            <Accordion.Body>
                              <p>
                                Our healthcare app developers create apps that
                                provide an extensive amount of medical insights
                                and advice, boosting health awareness and
                                wellness.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="5">
                            <Accordion.Header>Geolocation</Accordion.Header>
                            <Accordion.Body>
                              <p>
                                Our healthcare app uses geolocation technologies
                                to enable users to easily find nearby healthcare
                                professionals, clinics, and facilities.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={6}
                        xl={7}
                        xxl={7}
                        className="text-center offset-lg-1"
                      >
                        <div className="top_health_img">
                          <StaticImage
                            src="../../images/services-usa/healthcare-new/top_features/apps_for_medical.webp"
                            alt="apps-for-medical"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={782}
                            height={545}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Tab.Pane>
                </Tab.Content>
              </Row>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Topfeatures;
